import { ConsultaEstadoComponent } from './modules/consultaestado/view/consultaestado.component';
import { Routes } from '@angular/router';

export const ROUTES: Routes = [
  {path: '', redirectTo: 'consulta-tramite', pathMatch: 'full'},
  {path: 'consulta-tramite', component: ConsultaEstadoComponent},
  {path: '**',  redirectTo: 'consulta-tramite'}
];
